exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".memberBalanceDetails[data-v-49dfe2e0]{padding:20px;height:93vh;background:#fff;overflow-y:auto}", ""]);

// exports
